module.exports = __webpack_public_path__ + "img/day_line.30183e58.svg";